import { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import Pages from '@/pages';

const ACT_FORM_BASE_PATH = {
  meteringPoint: (pointId: string) =>
    `../${Pages.METERING_POINTS}/${pointId}/${Pages.METERING_POINT_ACTS}`,
  commercialMeteringPoint: (pointId: string) =>
    `../${Pages.COMMERCIAL_METERING_POINTS_PART}/${pointId}/${Pages.DOCUMENTS_AND_ACTS}`,
  commercialMeteringPointEditAct: (pointId: string) =>
    `../${Pages.COMMERCIAL_METERING_POINTS_PART}/${pointId}/${Pages.METERING_POINT_ACTS}`,
  gasThreadMeteringPoint: (pointId: string, gasThreadId: string) =>
    `../${Pages.GAS_THREADS}/${gasThreadId}/${Pages.METERING_POINTS}/${pointId}/${Pages.METERING_POINT_ACTS}`,
};

export const useActFormBasePath = (
  currentView: 'meteringPoint' | 'commercialMeteringPoint' = 'meteringPoint',
) => {
  const {
    meteringPointId,
    commercialMeteringPointId,
    meteringPointActId,
    gasThreadId,
  } = useParams<{
    meteringPointId?: string;
    commercialMeteringPointId?: string;
    meteringPointActId?: string;
    gasThreadId?: string;
  }>();

  return useMemo(() => {
    const isEditMode = !!meteringPointActId;
    const isCommercialMeteringPointView =
      currentView === 'commercialMeteringPoint';

    const pointId = meteringPointId || commercialMeteringPointId;

    if (gasThreadId) {
      const basePath = ACT_FORM_BASE_PATH[currentView](pointId);
      return isEditMode
        ? ACT_FORM_BASE_PATH['gasThreadMeteringPoint'](pointId, gasThreadId) +
            `/${meteringPointActId}`
        : basePath;
    }

    if (isCommercialMeteringPointView) {
      const basePath = ACT_FORM_BASE_PATH[currentView](pointId);
      return isEditMode
        ? ACT_FORM_BASE_PATH['commercialMeteringPointEditAct'](pointId) +
            `/${meteringPointActId}`
        : basePath;
    }

    const basePath = ACT_FORM_BASE_PATH[currentView](pointId);

    return isEditMode ? basePath + `/${meteringPointActId}` : basePath;
  }, [
    commercialMeteringPointId,
    currentView,
    gasThreadId,
    meteringPointActId,
    meteringPointId,
  ]);
};
